import { HpmsCustomCardApi, HpmsCustomContentCollapseApi, HpmsCustomContentCollapseEvent, HPMSOnOpenCollapse } from '@philips-emr/hpms-health-insurance-components';
import { AvatarAPI, FieldAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { Data } from '@philips-emr/tws-core/lib/component/context/data-context';
import { FetchEvent, MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { DiscreditedProvidersDialogAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { CardDetailFull, DISCREDITED, DiscreditedProvider, GeneralParams, ProviderLegends, SUBSTITUTE } from './discredited-provider-controller';
import { mountCardFragment } from './icons-button-utils';

export interface ItemDetail extends Record<string, Value> {
  nrSeqProvider: number;
  nmProvider: string;
  dsSpeciality: string;
  dsArea: string;
  dsAddress: string;
  dsPhone: string;
  dsAddressGmaps: string;
  dsEmail: string;
  dsWebSite: string;
  dsTypeProvider: string;
  dsCnpjCrm: string;
  legends: ProviderLegends;
}

@Controller({ fragment: FragmentNames.DISCREDITED_PROVIDERS_DIALOG })
export default class DiscreditedProvidersModalController extends BaseController {

  @OnMount(Aliases.HPMS_CUSTOM_CARD_0)
  onCardMount(event: MountEvent): void {
    const api = event.target as HpmsCustomCardApi;
    api.setState({ collapsed: false });
  }

  @OnMount([
    Aliases.TEXT_DT_PUBLISHED,
    Aliases.TEXT_DT_END_PROVIDER,
  ])
  onMountDtPublished(event: MountEvent): void {
    const api = event.target as FieldAPI;
    const { dataParams } = this.context.getBulkData();
    
    const discreditedProvider = dataParams as DiscreditedProvider;

    api.setValue(
      api.getAlias() == Aliases.TEXT_DT_PUBLISHED
        ? discreditedProvider.dtPublished
        : discreditedProvider.dtEndProvider
    );
  }

  @OnMount(Aliases.AVATAR_USER)
  onMountAvatar(event: MountEvent): void {
    const api = event.target as AvatarAPI;
    const { dataParams } = this.context.getBulkData();
    api.setTitle((dataParams as DiscreditedProvider).nmProviderDesc);
    api.setSubtitle((dataParams as DiscreditedProvider).cdProviderDesc);
  }

  @HPMSOnOpenCollapse(Aliases.HPMS_CUSTOM_CARD_CONTENT_COLLAPE_D)
  onOpenRenderContentD(event: HpmsCustomContentCollapseEvent<Data>): void {
    if (!event || !event.data) {
      return;
    }
    const { onOpenRender } = event;
    const { dataParams } = this.context.getBulkData();
    onOpenRender({ parameters: { nrSeqProviderExcl: (dataParams as DiscreditedProvider).nrSeqProviderExcl, ieType: DISCREDITED } });
  }

  @OnAfterFetch(Aliases.HPMS_CUSTOM_CARD_CONTENT_COLLAPE_D)
  onAfterFetchContentD(event: FetchEvent): void {
    const api = event.target as HpmsCustomContentCollapseApi;
    const data = event.data as CardDetailFull;

    const { ieType } = data;
    if (ieType !== DISCREDITED) api.setVisible(false);
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_D)
  onDynamicContentRenderD(event: RenderEvent): void {
    const { render, data } = event;
    const cardDetailFull = (data as CardDetailFull);

    if (cardDetailFull.nrSeqProvider == undefined) return;

    const compactName = `${cardDetailFull.nmProvider} - ${cardDetailFull.cdProviderDesc}`;
    const nrSeqProvider = cardDetailFull.nrSeqProvider;

    const { legendsBasePath, generalParams } = this.context.getBulkData();

    mountCardFragment(render, {
      nrSeqProvider, compactName, legendsBasePath, ...(generalParams as GeneralParams),
    });
  }

  @HPMSOnOpenCollapse(Aliases.HPMS_CUSTOM_CARD_CONTENT_COLLAPE_S)
  onOpenRenderContentS(event: HpmsCustomContentCollapseEvent<Data>): void {
    if (!event || !event.data) {
      return;
    }
    const { onOpenRender } = event;
    const { dataParams } = this.context.getBulkData();
    onOpenRender({ parameters: { nrSeqProviderExcl: (dataParams as DiscreditedProvider).nrSeqProviderExcl, ieType: SUBSTITUTE } });
  }

  @OnAfterFetch(Aliases.HPMS_CUSTOM_CARD_CONTENT_COLLAPE_S)
  onAfterFetchContentS(event: FetchEvent): void {
    const api = event.target as HpmsCustomContentCollapseApi;
    const data = event.data as CardDetailFull;

    const { ieType } = data;
    if (ieType !== SUBSTITUTE) api.setVisible(false);
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_S)
  onDynamicContentRenderS(event: RenderEvent): void {
    const { render, data } = event;
    const cardDetailFull = (data as CardDetailFull);

    if (cardDetailFull.nrSeqProviderSubst == undefined) return;

    const compactName = `${cardDetailFull.nmProvider} - ${cardDetailFull.cdProviderDesc}`;
    const nrSeqProvider = cardDetailFull.nrSeqProviderSubst;

    const { legendsBasePath, generalParams } = this.context.getBulkData();

    mountCardFragment(render, {
      nrSeqProvider, compactName, legendsBasePath, ...(generalParams as GeneralParams),
    });
  }
}
